<template>
  <div>
    <head-nav-bar title="入账" :fixed="true" />
    <div class="mt-header-nav">
      <div class="roomInfo">
        <van-row class="title">
          <van-col span="12">房间列表</van-col>
          <van-col span="12" class="all" @click="hanldeSelectRoom">
            <span>全选 </span>
            <van-switch
              v-model="checked"
              style=" vertical-align: -3px;"
              size="16px"
              active-color="#07c160"
              inactive-color="#ccc"
            />
          </van-col>
        </van-row>
        <van-checkbox-group v-model="selectRoom">
          <van-row
            style="padding: 3px 10px;"
            v-for="item in roomInfo"
            :key="item.Id"
          >
            <van-col span="22" style="font-size: 15px;">
              {{ item.RoomTypeName }}-{{ item.RoomNo }}
            </van-col>
            <van-col span="2" style="margin-top: 5px;">
              <van-checkbox :name="item.RoomId" style="margin-top: -4px;" />
            </van-col>
          </van-row>
        </van-checkbox-group>
      </div>

      <div class="inAccountItem">
        <van-row class="title">
          <van-col span="12">入账项目</van-col>
          <van-col span="12"
            ><van-field
              v-model="keyword"
              placeholder="关键字"
              style="padding: 1px 5px;"
              @input="onSearch"
          /></van-col>
        </van-row>
        <van-tabs
          v-model="tabName"
          @click="onTabClick"
          title-active-color="#098ae8"
        >
          <van-tab
            v-for="(item, index) in tabArr"
            :key="index"
            :title="item.title"
            :name="item.name"
          />
        </van-tabs>
        <div class="items">
          <van-row>
            <template v-for="(item, index) in items">
              <van-col
                span="5"
                class="item"
                v-if="!item.isHiddenItem"
                :key="index"
                @click="addDetail(item)"
              >
                <p class="cosum-name">{{ item.Name }}</p>
                <p class="price">{{ item.UnitPrice }}</p>
              </van-col>
            </template>
          </van-row>
        </div>
      </div>

      <div class="details">
        <van-row class="title">
          <van-col span="12">项目明细</van-col>
        </van-row>

        <van-row class="detail-title">
          <van-col span="1"></van-col>
          <van-col span="3">房号</van-col>
          <van-col span="7">项目</van-col>
          <van-col span="3">数量</van-col>
          <van-col span="3">单价</van-col>
          <van-col span="3">单据号</van-col>
          <van-col span="4">总金额</van-col>
        </van-row>
        <div class="detail">
          <van-row v-for="(item, index) in details" :key="index">
            <van-col span="1">
              <van-icon
                name="clear"
                size="20"
                color="#f00"
                style="margin-top: -1px;"
                @click="delDetail(index)"
              />
            </van-col>
            <van-col span="3">{{ item.RoomNo }}</van-col>
            <van-col span="7">{{ item.AccountItemName }}</van-col>
            <van-col span="3">
              <input class="input" v-model="item.Quantity" />
            </van-col>
            <van-col span="3">
              <span style="color:#4776f3" v-if="item.cannotEditable">{{
                item.UnitPrice
              }}</span>
              <input v-model="item.UnitPrice" class="input" v-else />
            </van-col>
            <van-col span="3">
              <input v-model="item.BillNo" class="input" />
            </van-col>
            <van-col span="4">
              {{ (item.Quantity * item.UnitPrice).toFixed(2) }}
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="submit">
        <van-button type="info" round block @click="onSubmit">
          确认
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import orderApi from "../../api/order.js";
import { GetAccountList } from "../../api/common";
import moment from "moment";
import { mapState } from "vuex";
import { cloneDeep, debounce } from "lodash";
import accountMaintenanceApi from "@/api/accountMaintenance";
import roomApi from "@/api/room.js";
import {
  Row,
  Col,
  Checkbox,
  Picker,
  Popup,
  Field,
  Button,
  Tab,
  Tabs,
  Cell,
  CellGroup,
  Icon,
  CheckboxGroup,
  Notify,
  Switch,
} from "vant";
export default {
  name: "OrderInAccount",
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Checkbox.name]: Checkbox,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Button.name]: Button,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [CheckboxGroup.name]: CheckboxGroup,
    [Switch.name]: Switch,
  },
  data() {
    return {
      tabName: "-1",
      // swipeThreshold: 6,
      roomInfo: [], //房间列表
      selectRoom: [], //当前选择的房间
      allItems: [],
      tabArr: [{ name: "-1", title: "全部" }],
      items: [], //根据tab选项展示的消费项
      details: [], //项目明细
      checked: false,
      accountItemLists: [],
      accountList: [],
      baseAllItems: [],
      accountObj: {},
      keyword: "",
    };
  },
  model: {},
  created() {
    this.orderId = this.$route.query.id;
    this.init();
    this.getAccountAttributes();
  },
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  watch: {},
  methods: {
    onSearch: debounce(function() {
      let val = this.keyword;
      this.tabName = "-1";
      const data = cloneDeep(this.baseAllItems);
      let items = [];
      if (val) {
        val = val.trim().toUpperCase();
        items = data.filter(
          item => item.Keyword && item.Keyword.toUpperCase().includes(val),
        );
      } else {
        items = data;
      }
      this.items = items;
    }, 300),
    hanldeSelectRoom() {
      if (this.checked) {
        this.selectRoom = [];
        this.roomInfo.forEach(el => {
          this.selectRoom.push(el.RoomId);
        });
      } else {
        this.selectRoom = [];
      }
    },
    //获取可选项的属性
    caculateAttributes(item) {
      const attributes = item.Attributes;
      const currentSelect = [];
      for (let k = 0; k < this.accountItemLists.length; k++) {
        const accountItem = this.accountItemLists[k];
        if ((attributes | accountItem.Item) == attributes) {
          currentSelect.push(accountItem.Item);
        }
      }
      return currentSelect;
    },
    //获取账项属性
    getAccountAttributes() {
      accountMaintenanceApi
        .GetAccountAttributes("AccountAttributes_Get")
        .then(res => {
          const data = res.Data.filter(v => v.Type == "D");
          this.accountItemLists = data[0].AccountItemLists;
          this.onGetAccountList();
        });
    },
    init() {
      orderApi.getOrderDetail({ id: this.orderId }).then(res => {
        res.Data.Details.forEach(el => {
          if (el.OrderStatus == 1 || el.OrderStatus == 3) {
            this.roomInfo.push(el);
          }
        });
        //只有一间房间时默认选中
        // if (this.roomInfo.length == 1) {
        this.selectRoom.push(this.roomInfo[0].RoomId);
        // }
        //获取每一间房的全日租房价
        this.roomInfo.forEach(item => {
          const start = this.user.AccountDate;
          const end = moment(this.user.AccountDate)
            .add("d", 1)
            .format("YYYY-MM-DD");
          orderApi
            .getTransactionPriceList({
              Id: this.orderId,
            })
            .then(res => {
              const detail = res.Data.find(el => {
                return el.OrderDetailId == item.Id && el.PriceDate == start;
              });
              if (detail != undefined) {
                item.RoomPrice = detail.Price;
              } else {
                const params = {
                  CheckInDate: start,
                  CheckOutDate: end,
                  RoomTypeId: item.RoomTypeId,
                  PriceCodeId: res.Data.PriceCodeId,
                };
                roomApi.GetRoomPrice(params).then(res => {
                  item.RoomPrice = res.Data[0].Price;
                });
              }
            });
        });
      });
    },
    onGetAccountList() {
      GetAccountList().then(res => {
        let obj = {};
        res.Data.forEach(item => {
          this.tabArr.push({
            name: item.Id,
            title: item.TypeName,
          });
          obj[item.Id] = item;
          if (item.AccountItems && item.AccountItems.length > 0) {
            item.AccountItems = item.AccountItems.map(el => {
              const currentSelect = this.caculateAttributes(el);
              if (currentSelect.includes(256)) {
                //不可输入
                el.isHiddenItem = true;
              }
              if (currentSelect.includes(16384)) {
                //不可修改
                el.cannotEditable = true;
              }
              if (currentSelect.includes(8)) {
                //全日租
                el.isDayRent = true;
              }
              if (currentSelect.includes(16)) {
                // 半日租
                el.isHalfDayRent = true;
              }
              return el;
            });
            this.allItems = this.allItems.concat(item.AccountItems);
          }
          obj[item.Id].AccountItems = item.AccountItems;
        });
        this.items = this.allItems; //默认展示所有消费项

        obj["-1"] = {
          Id: "-1",
          TypeName: "全部",
          AccountItems: this.allItems,
        };
        this.accountObj = obj;
        this.baseAllItems = cloneDeep(this.allItems);
      });
    },
    onTabClick(value) {
      this.tabName = value;
      this.keyword = "";
      this.items = this.accountObj[value].AccountItems;
    },
    addDetail(item) {
      if (this.selectRoom.length <= 0) {
        Notify("请选择房间");
        return false;
      }
      this.selectRoom.forEach(el => {
        let room = this.roomInfo.find(p => p.RoomId == el);
        this.details.push({
          GuestId: room.Persons[0].Id,
          RoomNo: room.RoomNo,
          AccountItemId: item.Id,
          AccountItemName: item.Name,
          UnitPrice: item.isDayRent
            ? room.RoomPrice
            : item.isHalfDayRent
            ? room.RoomPrice / 2
            : item.UnitPrice,
          Quantity: 1,
          BillNo: room.RoomNo,
          AccountRemark: "",
          cannotEditable: item.cannotEditable,
        });
      });
    },
    delDetail(index) {
      this.details.splice(index, 1);
    },
    onSubmit() {
      if (this.details.length <= 0) {
        Notify("请选择消费项目");
        return false;
      }
      // let index = this.details.findIndex(p => Number(p.UnitPrice) == 0);
      // if (index > -1) {
      //   Notify("存在为0的消费项");
      //   return false;
      // }
      orderApi.addConsume(this.details).then(() => {
        Notify({ type: "success", message: "操作成功" });
        this.$router.push({ name: "OrderDetail", query: { id: this.orderId } });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  padding: 5px 10px;
  font-size: 14px;
  color: #999999;
  background: #f2f3f5;
  line-height: 23px;
  .all {
    text-align: right;
    color: #1989fa;
  }
}
.items {
  height: 250px;
  overflow: auto;
  margin-bottom: 8px;
  .item {
    height: 44px;
    padding: 5px;
    background-color: #fff0ec;
    margin-left: 10px;
    margin-top: 5px;
    /* float: left; */
    font-size: 13px;
    text-align: center;
    .price {
      color: #f00;
      font-size: 12px;
    }
  }
}
.cosum-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.details {
  clear: both;
  .detail-title {
    text-align: center;
    font-size: 13px;
    padding: 2px 5px;
    background: #e7f3ff;
    margin-top: 3px;
  }
  .detail {
    text-align: center;
    color: #666;
    .van-row {
      font-size: 12px;
      padding: 2px 5px;
      border-bottom: 1px dashed #eee;
      .input {
        width: 44px;
        height: 20px;
        border: 1px solid #eee;
        border-radius: 3px;
        padding: 0 3px;
      }
    }
  }
}
.submit {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  padding: 5px 16px;
  background-color: #fff;
}
</style>
